import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import api from "../../util/panelApi";
import { useI18n } from "../../util/i18n";
import { img } from "./kit";

const nf = (n) => (Number(n) || 0).toLocaleString("tr-TR");
const usd = (n) => `$${(Number(n) || 0).toFixed(2)}`;

/// Bugünü düne göre kıyaslayan ok. Artı yeşil, eksi kırmızı.
const Delta = ({ now, prev }) => {
  const a = Number(now) || 0;
  const b = Number(prev) || 0;
  if (b === 0 && a === 0) return null;
  const pct = b === 0 ? 100 : Math.round(((a - b) / b) * 100);
  const up = pct >= 0;
  return (
    <span
      style={{
        fontSize: 11.5,
        fontWeight: 700,
        color: up ? "#1B7F3B" : "#B3261E",
        background: up ? "rgba(52,199,89,.14)" : "rgba(255,59,48,.12)",
        borderRadius: 99,
        padding: "1px 7px",
        marginInlineStart: 8,
        whiteSpace: "nowrap",
      }}
    >
      {up ? "▲" : "▼"} {Math.abs(pct)}%
    </span>
  );
};

/// Küçük kişi satırı: sıra, avatar, ad, değer.
const Row = ({ rank, p, value, sub, pct }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0" }}>
    <span
      style={{
        width: 18,
        textAlign: "center",
        fontSize: 12,
        fontWeight: 800,
        color: rank <= 3 ? "#B8860B" : "#9CA3AF",
      }}
    >
      {rank}
    </span>
    {p.image ? (
      <img
        src={img(p.image)}
        alt=""
        style={{ width: 30, height: 30, borderRadius: "50%", objectFit: "cover" }}
      />
    ) : (
      <div style={{ width: 30, height: 30, borderRadius: "50%", background: "#EEF0F4" }} />
    )}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 13.5, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {p.name}
      </div>
      {p.uniqueId ? <div style={{ fontSize: 11.5, color: "#6E6E73" }}>ID {p.uniqueId}</div> : null}
    </div>
    <div style={{ textAlign: "end" }}>
      <div style={{ fontSize: 13.5, fontWeight: 800 }}>{value}</div>
      {sub ? <div style={{ fontSize: 11, color: "#6E6E73" }}>{sub}</div> : null}
      {pct != null ? (
        <div className="pulse-bar">
          <i style={{ width: `${Math.max(4, Math.min(100, pct))}%` }} />
        </div>
      ) : null}
    </div>
  </div>
);

/// Panelin üst bölümü: bugünün özeti, canlı durum, bekleyen işler, listeler.
const Pulse = () => {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saat, setSaat] = useState(null);

  const load = useCallback(async () => {
    const r = await api.pulse();
    if (r?.status) {
      setD(r);
      setSaat(new Date());
    }
  }, []);

  useEffect(() => {
    load();
    // canlı sayılar 30 saniyede bir tazelenir
    const timer = setInterval(load, 30000);
    return () => clearInterval(timer);
  }, [load]);

  if (!d) return <div className="badu-empty">{t("Yükleniyor…")}</div>;

  const { today, prev, live, todo, topHosts, topSpenders, recentBuys } = d;

  const big = (label, value, now, before, to, ikon, renk, onceki) => (
    <Link to={to || "#"} className="badu-tile pulse-kpi" key={label} style={{ "--k": renk }}>
      <div className="pulse-kpi-top">
        <span className="pulse-ikon">{ikon}</span>
        <p className="badu-lbl" style={{ margin: 0 }}>{t(label)}</p>
      </div>
      <div className="badu-val pulse-num" style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
        {value}
        <Delta now={now} prev={before} />
      </div>
      <div className="pulse-dun">
        {t("Dün")}: {onceki}
      </div>
    </Link>
  );

  const chip = (label, value, color) => (
    <div key={label} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0" }}>
      <span className={value > 0 ? "pulse-dot" : ""} style={{ width: 8, height: 8, borderRadius: 99, background: color, flex: "none", color }} />
      <span style={{ flex: 1, fontSize: 13, color: "#3A3A3C" }}>{t(label)}</span>
      <b style={{ fontSize: 14 }}>{nf(value)}</b>
    </div>
  );

  return (
    <div className="cam-sayfa">
      {/* bugünün özeti: AYVO geçişli bant */}
      <div className="cam-hero">
        {[
          ["🎁", "Hediye hacmi", nf(today.giftCoin), today.giftCoin, prev.giftCoin, nf(prev.giftCoin), "/admin/moneyLogs?tab=gifts"],
          ["💵", "Coin geliri", usd(today.revenueUsd), today.revenueUsd, prev.revenueUsd, usd(prev.revenueUsd), "/admin/moneyLogs?tab=purchases"],
          ["🛒", "Satın alma", nf(today.purchases), today.purchases, prev.purchases, nf(prev.purchases), "/admin/moneyLogs?tab=purchases"],
          ["👤", "Yeni kullanıcı", nf(today.newUsers), today.newUsers, prev.newUsers, nf(prev.newUsers), "/admin/user"],
        ].map(([ikon, label, val, now, before, onceki, to]) => {
          const a = Number(now) || 0, b = Number(before) || 0;
          const pct = b === 0 ? (a === 0 ? null : 100) : Math.round(((a - b) / b) * 100);
          return (
            <Link key={label} to={to} className="cam-kpi">
              <small>
                {ikon} {t(label)}
              </small>
              <b>{val}</b>
              <span>
                {pct == null ? "—" : `${pct >= 0 ? "▲" : "▼"} ${Math.abs(pct)}%`} · {t("Dün")} {onceki}
              </span>
            </Link>
          );
        })}
      </div>

      <div className="badu-bento" style={{ marginBottom: 14 }}>
        {/* canlı durum */}
        <div className="badu-tile span-2">
          <div className="badu-tile-head">
            <b style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span className="pulse-live">
                <i />
                {t("CANLI")}
              </span>
              {t("Canlı durum")}
            </b>
            <span style={{ fontSize: 11.5, color: "#6E6E73" }}>
              {saat ? `${t("Güncellendi")} ${saat.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit", second: "2-digit" })} · ` : ""}
              {t("Son 1 saat")}: {nf(live.hourGiftCoin)} {t("coin")} · {nf(live.hourGiftCount)} {t("hediye")}
            </span>
          </div>
          <div className="cam-live">
            <div
              className="cam-ring"
              style={{
                background: `conic-gradient(#C026D3 0 ${(live.onlineUsers / Math.max(1, live.onlineUsers + live.onlineHosts)) * 100}%, #2563EB 0 100%)`,
              }}
            >
              <div>
                <b>{nf(live.onlineUsers + live.onlineHosts)}</b>
                <small>{t("çevrimiçi")}</small>
              </div>
            </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", columnGap: 18, flex: 1 }}>
            {chip("Çevrimiçi kullanıcı", live.onlineUsers, "#34C759")}
            {chip("Çevrimiçi yayıncı", live.onlineHosts, "#0A84FF")}
            {chip("Şu an yayında", live.liveNow, "#FF3B30")}
            {chip("Açık oda", live.activeRooms, "#AF52DE")}
            {chip("Odalardaki kişi", live.roomPeople, "#FF9F0A")}
            {chip("Süren PK", live.livePk, "#FF2D55")}
          </div>
          </div>
        </div>

        {/* bekleyen işler */}
        <div className="badu-tile span-2">
          <div className="badu-tile-head">
            <b>{t("Bekleyen işler")}</b>
          </div>
          {[
            ["Yayıncı başvurusu", todo.pendingHosts, "/admin/hostRequest"],
            ["Çekim talebi", todo.pendingWithdraw, "/admin/pendingRedeem"],
            ["Açık şikayet", todo.openComplaints, "/admin/pendingComplaint"],
          ].map(([label, n, to]) => (
            <Link
              key={label}
              to={to}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 0",
                borderBottom: "1px solid rgba(0,0,0,.055)",
                color: "inherit",
              }}
            >
              <span style={{ flex: 1, fontSize: 13.5 }}>{t(label)}</span>
              <span
                style={{
                  minWidth: 26,
                  textAlign: "center",
                  fontSize: 12.5,
                  fontWeight: 800,
                  borderRadius: 99,
                  padding: "2px 8px",
                  color: n > 0 ? "#fff" : "#8E8E93",
                  background: n > 0 ? "#FF3B30" : "rgba(0,0,0,.05)",
                }}
              >
                {nf(n)}
              </span>
            </Link>
          ))}
        </div>
      </div>

      {/* listeler */}
      <div className="badu-bento" style={{ marginBottom: 14 }}>
        <div className="badu-tile span-2">
          <div className="badu-tile-head">
            <b>{t("Bugün en çok kazananlar")}</b>
          </div>
          {topHosts.length === 0 ? (
            <div style={{ color: "#8E8E93", fontSize: 13, padding: "14px 0" }}>{t("Kayıt yok.")}</div>
          ) : (
            topHosts.map((h, i) => <Row key={h.id + i} rank={i + 1} p={h} value={nf(h.coin)} pct={(h.coin / (topHosts[0]?.coin || 1)) * 100} />)
          )}
        </div>

        <div className="badu-tile span-2">
          <div className="badu-tile-head">
            <b>{t("Bugün en çok harcayanlar")}</b>
          </div>
          {topSpenders.length === 0 ? (
            <div style={{ color: "#8E8E93", fontSize: 13, padding: "14px 0" }}>{t("Kayıt yok.")}</div>
          ) : (
            topSpenders.map((u, i) => <Row key={u.id + i} rank={i + 1} p={u} value={nf(u.coin)} pct={(u.coin / (topSpenders[0]?.coin || 1)) * 100} />)
          )}
        </div>

        <div className="badu-tile span-4">
          <div className="badu-tile-head">
            <b>{t("Son satın almalar")}</b>
            <Link to="/admin/moneyLogs?tab=purchases" style={{ fontSize: 12.5 }}>
              →
            </Link>
          </div>
          {recentBuys.length === 0 ? (
            <div style={{ color: "#8E8E93", fontSize: 13, padding: "14px 0" }}>{t("Kayıt yok.")}</div>
          ) : (
            recentBuys.map((p, i) => (
              <Row
                key={p.id + i}
                rank={i + 1}
                p={p}
                value={usd(p.usd)}
                sub={`${nf(p.coin)} ${t("coin")}`}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Pulse;
